declare namespace $ {

	type $mol_button_major__sub_shm_hitalama_opencode_map_sessions_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_hitalama_opencode_map_sessions_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_sessions['new_session'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_list__rows_shm_hitalama_opencode_map_sessions_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_sessions['session_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_hitalama_opencode_map_sessions_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_opencode_map_sessions_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_sessions['session_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__attr_shm_hitalama_opencode_map_sessions_6 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_opencode_map_sessions['session_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__click_shm_hitalama_opencode_map_sessions_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_sessions['session_select'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_hitalama_opencode_map_sessions extends $mol_pick {
		Sessions_icon( ): $mol_icon_chat
		New_session_icon( ): $mol_icon_plus
		new_session( next?: any ): any
		New_session( ): $mol_button_major
		session_rows( ): readonly(any)[]
		Sessions( ): $mol_list
		Content( ): $mol_view
		session_title( id: any): string
		session_current( id: any): boolean
		session_select( id: any, next?: any ): any
		server_url( ): string
		map_id( ): string
		session_id( next?: string ): string
		new_session_model( ): any
		hint( ): string
		trigger_content( ): readonly(any)[]
		bubble_content( ): readonly(any)[]
		Session_row( id: any): $mol_button_minor
	}
	
}

//# sourceMappingURL=sessions.view.tree.d.ts.map